import React, { FC } from 'react'
import { Redirect, Route, RouteComponentProps } from 'react-router'
import { observer } from 'mobx-react-lite'
import { useAppContext } from './config/context'
import { YodaSpinnerPage } from './utils/YodaSpinnerPage'

// TODO : mutualiser cette classe avec celle de l'admin

export interface RouteDefinition {
  path: string
  Component: React.FunctionComponent<RouteComponentProps<any> & { routes?: RouteDefinition[] }> // si on met le 'C' en minuscule on peut pas utiliser de hooks
  title?: string
  routes?: RouteDefinition[]
  secured?: boolean
  renderCondition?: () => boolean
  waitCondition?: () => boolean
}

export const RouteWithSubRoutes: FC<RouteDefinition> = observer((rtDef: RouteDefinition) => {
  const { authStore } = useAppContext()
  const display = !rtDef.renderCondition || rtDef.renderCondition()
  const wait =
    (rtDef.waitCondition && rtDef.waitCondition()) ||
    (rtDef.secured && authStore.authStatus === 'PENDING')
  const validAuth = !rtDef.secured || authStore.authStatus === 'AUTHENTICATED'
  return (
    <Route
      path={rtDef.path}
      render={(props) => (
        <>
          {wait ? (
            <YodaSpinnerPage />
          ) : (
            <>
              {!validAuth && <Redirect to={'/unauthorized'} />}
              {!display && <Redirect to={'/'} />}
              <rtDef.Component {...props} routes={rtDef.routes} />
            </>
          )}
        </>
      )}
    />
  )
})
